import { useTranslation } from "react-i18next";
import bg1 from "../assests/solutions/pro-1.jpg";
import bg1ar from "../assests/solutions/pro-1ar.jpg";
import robotImg from "../assests/solutions/pro-2.png";

import bg from "../assests/solutions/cloud-9.jpeg";
import './SOE.css';
import './ProcessIntegration.css'
import Approach from "./Approach";
import ZigZag from "./ZigZag";
import img1 from "../assests/solutions/pro-img1.jpg";
import img2 from "../assests/solutions/pro-img2.jpg";
import img3 from "../assests/solutions/pro-img3.jpg";
import Partnerships from "./Partnerships";
import logo1 from "../assests/solutions/logo-1.png";
import logo2 from "../assests/solutions/logo-2.png";
import logo3 from "../assests/solutions/logo-3.png";
import Header from "../Home/Header";
import Footer from "../Footer/Footer";
const ProcessIntegration = () => {

    const { i18n } = useTranslation();
    const isArabic = i18n.language === "ar";
    const approachItems = [
        {
            step: 1,
            title: "Plan",
            description: "Strategically plan your Process Automation Implementation",
        },
        {
            step: 2,
            title: "Build",
            description:"Build and Harness the power of Workflows",
        },
        {
            step: 3,
            title: "Manage",
            description: "Deploy, orchestrate, and manage bots at scale",
        },
        {
            step: 4,
            title: "Deploy",
            description:"Stack Agnostic deployments to carry out process automation",
        },
        {
            step: 5,
            title: "Engage",
            description: "Engagement that enables Bots and Humans to work together",
        },
        {
            step: 6,
            title: "Measure",
            description: "Achieve strategic business outcomes with data analytics",
        },

    ];

    return (
        <>
            <div className="hd">
                <Header />
            </div>
            <section
                className="main-hero"
                style={{
                    backgroundImage: `url(${isArabic ? bg1ar : bg1})`
                }}

            >
                <div className="main-overlay" />

                <div className="main-hero-content" data-aos="fade-up" style={{ paddingLeft: isArabic ? "0px" : "70px", paddingRight: isArabic ? "70px" : "0px" }}>
                    <h1 className="main-title">
                        Process Integration
                    </h1>

                    <p className="main-subtitle">
                        Accelerating digital transformation through intelligent automation

                    </p>
                </div>

            </section>

            <section
                className={`intelligent-section ${isArabic ? "rtl" : ""}`}

            >
                <div className="intelligent-overlay"></div>

                <div className="intelligent-container">
                    {/* LEFT CONTENT */}
                    <div className="intelligent-content" data-aos="fade-up">
                        <h2>Intelligent Automation</h2>
                        <p>TTH'S Intelligent automation is helping companies transcend conventional performance tradeoffs to achieve unprecedented levels of efficiency and quality. With a combination of Robotic Process Automation (RPA) and artificial intelligence (AI) technologies, TTH solutions empower rapid end-to-end business process automation and accelerate digital transformation.</p>

                    </div>

                    {/* RIGHT IMAGE */}
                    <div className="intelligent-image">
                        <img src={robotImg} alt="Intelligent Automation" />
                    </div>
                </div>
            </section>



            <ZigZag
                title="Process Automation"
                description="TTH's developers are experts in Robotic Process Automation (RPA) and Artificial Intelligence (AI), delivering intelligent business process automation solutions across industries. With extensive experience working with global organizations, our team designs and implements automation that streamlines business processes, enhances technology operations, and optimizes individual business units. By combining deep domain knowledge with advanced automation frameworks, TTH helps enterprises improve efficiency, reduce operational costs, and achieve scalable, future-ready digital transformation."
                image={img1}
            >
            </ZigZag>

            <ZigZag
                title="Software Automation"
                description="TTH’s developers seamlessly integrate your machinery, tools, and software systems to deliver a faster, more reliable, and immersive automation experience. Our technology automation services include DevOps automation, CI/CD pipeline implementation, and containerization using Docker and Kubernetes, enabling streamlined development, efficient deployments, improved scalability, and continuous delivery that accelerates innovation while ensures operational stability and performance."
                image={img2}
                reverse
            >
            </ZigZag>
            <ZigZag
                title="Micro-Services Automation"
                description="TTH has extensive experience in microservices automation, supporting enterprises across architectures such as Microservices Architecture (MSA), Enterprise Service Bus (ESB), and Service-Oriented Architecture (SOA). From designing scalable integration frameworks to measuring and optimizing system performance, TTH helps organizations implement robust microservices automation that ensures seamless communication, improved agility, and reliable, future-ready enterprise systems."
                image={img3}
            >
            </ZigZag>


            <Approach
                title="Approach"
                data-aos="fade-up"
                backgroundImage={bg}
                items={approachItems}
            />


            <Partnerships
                title="Partnerships"
                subtitle="We have a robust ecosystem of ISVs to support our solutions and services"
                partners={[
                    { name: "SAP S/4HANA", logo: logo1 },
                    { name: "Oracle JD Edwards", logo: logo2 },
                    { name: "Microsoft Dynamics 365", logo: logo3 },

                ]}
            />

            <Footer />


        </>
    );
};

export default ProcessIntegration;